import script from "./shop-details-desc.vue?vue&type=script&setup=true&lang=js"
export * from "./shop-details-desc.vue?vue&type=script&setup=true&lang=js"

import "./shop-details-desc.vue?vue&type=style&index=0&id=59715c76&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59715c76"]])

export default __exports__